   
//   class DropdownRedirect {
//   constructor(selectElementId) {
//     const selectElement = document.getElementById(selectElementId);
//     if (selectElement) {
//       selectElement.addEventListener("change", (event) => this.redirect(event.target.value));
//     }
//   }
//   redirect(url) {
//     if (url) {
//       try {
//         window.location.href = new URL(url).href;
//       } catch {
//         console.error("The selected option is not a valid URL.");
//       }
//     }
//   }
// }

// document.addEventListener("DOMContentLoaded", () => new DropdownRedirect("choices")); 

 document.addEventListener("DOMContentLoaded", function () {
  const selectElement = document.getElementById("choices");
  if (selectElement) {      
    selectElement.addEventListener("change", function () {
      const selectedURL = this.value;
      if (selectedURL) {       
        window.location.href = selectedURL;
      }
    });
  }
});  


